import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Header2 from '../Header/Header2';
import Header3 from '../Header/Header3';




const Main = () => {
    return (
        <div>
            {/* <Header></Header> */}
            {/* <Header2></Header2> */}

            <Header3></Header3>

            <Outlet></Outlet>
            <Footer></Footer>
        </div>
    );
}; 

export default Main;